import React from 'react';
import { IDSSpinner } from '@inera/ids-react';

const FIXED_STYLE = {
    position: 'fixed',
    top: '1rem',
    right: '1.25rem',
    zIndex: 50,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    fontSize: '0.875rem',
    padding: '0.35rem 0.75rem',
    borderRadius: '4px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
    background: '#fff',
    pointerEvents: 'none',
};

const INLINE_STYLE = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    fontSize: '0.875rem',
};

/**
 * Autosave status indicator.
 *
 * @param {'idle'|'saving'|'saved'|'error'} status
 * @param {boolean} [fixed=false]  When true, renders in the top-right corner of the viewport.
 */
export default function AutosaveIndicator({ status, fixed = false }) {
    if (status === 'idle') return null;

    const base = fixed ? FIXED_STYLE : INLINE_STYLE;

    if (status === 'saving') {
        return (
            <span
                style={{ ...base, color: '#555' }}
                aria-live="polite"
                aria-label="Sparar automatiskt"
            >
                <IDSSpinner size="s" />
                Sparar…
            </span>
        );
    }

    if (status === 'saved') {
        return (
            <span
                style={{ ...base, color: '#1a7a35', ...(fixed && { border: '1px solid #b7dfbf' }) }}
                aria-live="polite"
                aria-label="Automatiskt sparat"
            >
                ✓ Sparat automatiskt
            </span>
        );
    }

    if (status === 'error') {
        return (
            <span
                style={{ ...base, color: '#c0392b', ...(fixed && { border: '1px solid #f5b7b1' }) }}
                aria-live="assertive"
                aria-label="Autosave misslyckades"
            >
                ⚠ Autosave misslyckades — spara manuellt
            </span>
        );
    }

    return null;
}
